import { render, staticRenderFns } from "./AddNewnessCard.vue?vue&type=template&id=248213ae&"
import script from "./AddNewnessCard.vue?vue&type=script&lang=js&"
export * from "./AddNewnessCard.vue?vue&type=script&lang=js&"
import style0 from "./AddNewnessCard.vue?vue&type=style&index=0&id=248213ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports